import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MailActionReplyParams } from 'src/app/shared/models/actions/mail-action-reply';
import { ActionStatutDTO } from 'src/app/shared/interfaces/actions/action-statut-dto.interface';
import { ActionTypesDTO } from 'src/app/shared/interfaces/actions/action-types-dto.interface';
import { environment } from 'src/environments/environment';
import { MailActionsDTO } from '../interfaces/actions/mail-action-dto.interface';
import { SearchMailsActionsParams } from '../models';
import { SearchActionPaginationDTO } from '../interfaces/actions/action-pagination-dto.interface';
import { MailUsersActionsAddOrReplaceParams } from '../models/actions/mail-users-actions';

@Injectable({
  providedIn: 'root',
})
export class ActionsService {
  public apiBaseUrl: string;
  public body: FormData;
  public params: HttpParams = new HttpParams();

  constructor(public http: HttpClient) {
    const config = environment;
    this.apiBaseUrl = config.apiICourrierBaseUrl;
    this.body = new FormData();
    this.params = new HttpParams();
  }

  public getAllActionsTypes(): Observable<ActionTypesDTO[]> {
    return this.http.get<ActionTypesDTO[]>(`${this.apiBaseUrl}/Global/Actions/Types`);
  }

  public getAllActionsStatutes(excludeNotUsed: boolean = false): Observable<ActionStatutDTO[]> {
    return this.http.get<ActionStatutDTO[]>(`${this.apiBaseUrl}/Global/Actions/Statutes?excludeNotUsed=${excludeNotUsed}`);
  }

  public getMailsActions(id: number): Observable<MailActionsDTO[]> {
    return this.http.get<MailActionsDTO[]>(`${this.apiBaseUrl}/Mails/${id}/Actions`);
  }

  public getAllActionsMails(datas?: SearchMailsActionsParams): Observable<SearchActionPaginationDTO> {
    if (datas) {
      let params = new HttpParams();
      Object.keys(datas).forEach((key) => (params = params.set(key, datas[key])));
      return this.http.get<SearchActionPaginationDTO>(`${this.apiBaseUrl}/Mails/Actions/Search?${params}`);
    } else {
      return this.http.get<SearchActionPaginationDTO>(`${this.apiBaseUrl}/Mails/Actions/Search`);
    }
  }

  public replyToMailAction(id: number, actionId: number, actionReply: MailActionReplyParams): Observable<void> {
    return this.http.post<void>(`${this.apiBaseUrl}/Mails/${id}/Actions/${actionId}/Reply`, actionReply);
  }

  public updateOrReplaceActions(courrierID: number, mailDestinataireInput: MailUsersActionsAddOrReplaceParams): Observable<void> {
    return this.http.post<void>(`${this.apiBaseUrl}/Mails/${courrierID}/Users/Actions/AddOrReplace`, mailDestinataireInput);
  }
}
